import React from 'react';

const DeLinkAccountSVGOld = ({ className, parentClassName }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2499 16.4501L17.7499 14.9001C18.4166 14.7167 18.9582 14.3625 19.3749 13.8376C19.7916 13.3125 19.9999 12.7 19.9999 12C19.9999 11.1667 19.7082 10.4584 19.1249 9.87505C18.5416 9.29172 17.8332 9.00005 16.9999 9.00005H12.9999V7.00005H16.9999C18.3832 7.00005 19.5624 7.48755 20.5374 8.46255C21.5124 9.43755 21.9999 10.6167 21.9999 12C21.9999 12.95 21.7541 13.825 21.2624 14.625C20.7707 15.425 20.0999 16.0334 19.2499 16.4501ZM15.8499 13L13.8499 11H15.9999V13H15.8499ZM19.7999 22.6L1.3999 4.20005L2.7999 2.80005L21.1999 21.2001L19.7999 22.6ZM10.9999 17.0001H6.9999C5.61657 17.0001 4.4374 16.5126 3.4624 15.5375C2.4874 14.5625 1.9999 13.3834 1.9999 12C1.9999 10.85 2.3499 9.82505 3.0499 8.92505C3.7499 8.02505 4.6499 7.43338 5.7499 7.15005L7.5999 9.00005H6.9999C6.16657 9.00005 5.45824 9.29172 4.8749 9.87505C4.29157 10.4584 3.9999 11.1667 3.9999 12C3.9999 12.8334 4.29157 13.5417 4.8749 14.125C5.45824 14.7084 6.16657 15 6.9999 15H10.9999V17.0001ZM7.9999 13V11H9.6249L11.5999 13H7.9999Z"
      fill="#0A7593"
    />
  </svg>
);

const DeLinkAccountSVG = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.25 16.45L17.75 14.9C18.4167 14.7167 18.9583 14.3625 19.375 13.8375C19.7917 13.3125 20 12.7 20 12C20 11.1667 19.7083 10.4583 19.125 9.87499C18.5417 9.29166 17.8333 8.99999 17 8.99999H13V6.99999H17C18.3833 6.99999 19.5625 7.48749 20.5375 8.46249C21.5125 9.43749 22 10.6167 22 12C22 12.95 21.7542 13.825 21.2625 14.625C20.7708 15.425 20.1 16.0333 19.25 16.45ZM15.85 13L13.85 11H16V13H15.85ZM19.8 22.6L1.39999 4.19999L2.79999 2.79999L21.2 21.2L19.8 22.6ZM11 17H6.99999C5.61666 17 4.43749 16.5125 3.46249 15.5375C2.48749 14.5625 1.99999 13.3833 1.99999 12C1.99999 10.85 2.34999 9.82499 3.04999 8.92499C3.74999 8.02499 4.64999 7.43332 5.74999 7.14999L7.59999 8.99999H6.99999C6.16666 8.99999 5.45833 9.29166 4.87499 9.87499C4.29166 10.4583 3.99999 11.1667 3.99999 12C3.99999 12.8333 4.29166 13.5417 4.87499 14.125C5.45833 14.7083 6.16666 15 6.99999 15H11V17ZM7.99999 13V11H9.62499L11.6 13H7.99999Z"
      fill="none"
      className={className}
    />
  </svg>
);

export { DeLinkAccountSVG };
